/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const User = {

	delete (context, userId, onSuccess, onError, options) {
		Api.delete(context,
			"/user"
			+ "?userId=" + userId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAccessProfileData (context, profiledUserId, onSuccess, onError, options) {
		Api.get(context,
			"/user/access-profile-data"
			+ "?profiledUserId=" + profiledUserId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAccountRemovalRequestStatus (context, onSuccess, onError, options) {
		Api.get(context,
			"/user/account-removal-request-status"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getIsTokenValid (context, onSuccess, onError, options) {
		Api.get(context,
			"/user/is-token-valid"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getListAgencyContestSupervisors (context, agencyContestId, onSuccess, onError, options) {
		Api.get(context,
			"/user/list-agency-contest-supervisors"
			+ "?agencyContestId=" + agencyContestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getListSupervisors (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/user/list-supervisors"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getUserAgency (context, onSuccess, onError, options) {
		Api.get(context,
			"/user/user-agency"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getUserBidderName (context, onSuccess, onError, options) {
		Api.get(context,
			"/user/user-bidder-name"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getUserDepartment (context, onSuccess, onError, options) {
		Api.get(context,
			"/user/user-department"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getUserInfo (context, onSuccess, onError, options) {
		Api.get(context,
			"/user/user-info"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getUserInfoById (context, userId, onSuccess, onError, options) {
		Api.get(context,
			"/user/user-info-by-id"
			+ "?userId=" + userId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getUserNotificationGroupData (context, userId, onSuccess, onError, options) {
		Api.get(context,
			"/user/user-notification-group-data"
			+ "?userId=" + userId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getUserSubBidderName (context, onSuccess, onError, options) {
		Api.get(context,
			"/user/user-sub-bidder-name"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getUserSubbiderType (context, onSuccess, onError, options) {
		Api.get(context,
			"/user/user-subbider-type"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getUserSystemRole (context, onSuccess, onError, options) {
		Api.get(context,
			"/user/user-system-role"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getValidateEmailEdition (context, email, onSuccess, onError, options) {
		Api.get(context,
			"/user/validate-email-edition"
			+ "?email=" + email
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getValidateEmailUniqueness (context, email, onSuccess, onError, options) {
		Api.get(context,
			"/user/validate-email-uniqueness"
			+ "?email=" + email
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postAccept (context, userEmailDTO, onSuccess, onError, options) {
		Api.post(context,
			"/user/accept"
			, userEmailDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postActivate (context, userEmailDTO, onSuccess, onError, options) {
		Api.post(context,
			"/user/activate"
			, userEmailDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postDeactivate (context, userEmailDTO, onSuccess, onError, options) {
		Api.post(context,
			"/user/deactivate"
			, userEmailDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putAccountRemovalRequest (context, onSuccess, onError, options) {
		Api.put(context,
			"/user/account-removal-request"
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putUndoAccountRemovalRequest (context, onSuccess, onError, options) {
		Api.put(context,
			"/user/undo-account-removal-request"
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
